import { DescriptionRounded } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import DATA_ITEM from "components/VideoData/types/DATA_ITEM";
import dataGetters from "components/VideoData/utils/dataGetters";
import VideoThumbnail from "components/VideoThumbnail";
import useGetParticipantById from "hooks/api/useGetParticipantById";
import useGetVideoById from "hooks/api/useGetVideoById";
import { flexCentered } from "theme/base/flex";
import { getTime } from "utils/display";
import TimelinePositions from "../types/TimelinePositions";
import getDetailsAtAbsoluteTime from "../utils/getDetailsAtAbsoluteTime";

interface Props {
  timelinePositions: TimelinePositions;
  value: number;
}

export default function Scrubber_ValueLabel({
  timelinePositions,
  value,
}: Props) {
  const { videoId } = getDetailsAtAbsoluteTime(value, timelinePositions);
  const { video } = useGetVideoById(videoId);
  const { participant } = useGetParticipantById(video?.participantId);

  return (
    <Stack style={flexCentered}>
      {videoId ? (
        <>
          <Stack style={flexCentered} width="5rem" height="5rem">
            <VideoThumbnail videoId={videoId} />
          </Stack>
          <Typography color="common.white">
            {dataGetters[DATA_ITEM.PARTICIPANT_NAME]({ participant })}
          </Typography>
        </>
      ) : (
        <DescriptionRounded sx={{ color: "common.white" }} fontSize="large" />
      )}
      <Typography color="common.white">{getTime(value)}</Typography>
    </Stack>
  );
}
